import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-558d7bea")

_pushScopeId("data-v-558d7bea")
const _hoisted_1 = { class: "p-fluid p-m-5" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "TENANT_NAME",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-col-12 kn-height-full" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "kn-material-input-label" }, "Tenant Logo", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("small", null, "The company/product logo, visible on the menu bar. If not present the default Knowage \"K\" will be shown.")
], -1)
const _hoisted_7 = { class: "imageContainer p-d-flex p-jc-center p-ai-center" }
const _hoisted_8 = {
  key: 0,
  class: "far fa-image fa-5x icon"
}
const _hoisted_9 = { for: "organizationImage" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_11 = { class: "p-col-12 kn-height-full" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "kn-material-input-label" }, "Tenant Logo Wide", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("small", null, "This logo will be used within dashboards XLSX exports. If no image is provided it will not be visible in those instances. The images should be below 200KB and in jpg or png format.")
], -1)
const _hoisted_14 = { class: "imageContainerExtended p-d-flex p-jc-center p-ai-center" }
const _hoisted_15 = {
  key: 0,
  class: "far fa-image fa-5x icon"
}
const _hoisted_16 = { for: "organizationImageExtended" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "pi pi-upload" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.tabViewDescriptor.card.style
  }, {
    content: _withId(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", {
          class: "p-field",
          style: _ctx.tabViewDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_InputText, {
              id: "TENANT_NAME",
              modelValue: _ctx.v$.tenant.TENANT_NAME.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.tenant.TENANT_NAME.$model = $event)),
              modelModifiers: { trim: true },
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.tenant.TENANT_NAME.$invalid && _ctx.v$.tenant.TENANT_NAME.$dirty
                            }],
              type: "text",
              disabled: _ctx.disableField,
              "max-length": "20",
              "data-test": "name-input",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.tenant.TENANT_NAME.$touch())),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFieldChange('TENANT_NAME', $event.target.value)))
            }, null, 8, ["modelValue", "disabled", "class"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            "v-comp": _ctx.v$.tenant.TENANT_NAME,
            "additional-translate-params": {
                            fieldName: _ctx.$t('common.name')
                        }
          }, null, 8, ["v-comp", "additional-translate-params"])
        ], 4),
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            (!_ctx.tenant.TENANT_IMAGE)
              ? (_openBlock(), _createBlock("i", _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.tenant.TENANT_IMAGE)
              ? (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _ctx.tenant.TENANT_IMAGE,
                  class: "kn-no-select"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("input", {
              id: "organizationImage",
              type: "file",
              accept: "image/png, image/jpeg",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
            }, null, 32),
            _withDirectives(_createVNode("label", _hoisted_9, [
              _hoisted_10
            ], 512), [
              [
                _directive_tooltip,
                _ctx.$t('common.upload'),
                void 0,
                { bottom: true }
              ]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            (!_ctx.tenant.TENANT_IMAGE_WIDE)
              ? (_openBlock(), _createBlock("i", _hoisted_15))
              : _createCommentVNode("", true),
            (_ctx.tenant.TENANT_IMAGE_WIDE)
              ? (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _ctx.tenant.TENANT_IMAGE_WIDE,
                  class: "kn-no-select"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("input", {
              id: "organizationImageExtended",
              type: "file",
              accept: "image/png, image/jpeg",
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadExtendedFile && _ctx.uploadExtendedFile(...args)))
            }, null, 32),
            _withDirectives(_createVNode("label", _hoisted_16, [
              _hoisted_17
            ], 512), [
              [
                _directive_tooltip,
                _ctx.$t('common.upload'),
                void 0,
                { bottom: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
})